/* Noura Nest — Luxe White: reveal, carousels, announcement rotator, quick add. No dependencies. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.nl-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  function carousels() {
    document.querySelectorAll('[data-nl-carousel]').forEach(function (root) {
      if (root.getAttribute('data-nl-ready')) return;
      root.setAttribute('data-nl-ready', '1');
      var track = root.querySelector('[data-nl-track]');
      var prev = root.querySelector('[data-nl-prev]');
      var next = root.querySelector('[data-nl-next]');
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  function rotators() {
    document.querySelectorAll('[data-nl-announce]').forEach(function (root) {
      if (root.getAttribute('data-nl-ready')) return;
      root.setAttribute('data-nl-ready', '1');
      var msgs = root.querySelectorAll('.nl-announce__msg');
      if (msgs.length < 2 || reduce) return;
      var i = 0, paused = false, delay = parseInt(root.getAttribute('data-delay'), 10) || 4500;
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, delay);
    });
  }

  var toastEl, toastTimer;
  function toast(text, cartUrl) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'nl-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '';
    var s = document.createElement('span'); s.textContent = text; toastEl.appendChild(s);
    if (cartUrl) { var a = document.createElement('a'); a.href = cartUrl; a.textContent = 'View cart'; toastEl.appendChild(a); }
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3800);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nl-quick]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-variant'), 10);
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'nl-quick-add', data: { source: 'nl-quick-add', itemCount: cart.item_count, variantId: String(id) } } })); } catch (err) {}
        btn.textContent = 'Added'; btn.classList.add('is-done');
        toast('Added to your cart', btn.getAttribute('data-cart-url'));
        setTimeout(function () { btn.textContent = label; btn.classList.remove('is-done'); btn.disabled = false; }, 2200);
      })
      .catch(function () { btn.disabled = false; toast('Sorry, that item could not be added. Please try again.'); });
  });

  function boot() { reveal(); carousels(); rotators(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();